import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { UserIdService } from '../../../auth/user-auth/facade';
import { LoginLogoutActionTypes } from '../../../auth/user-auth/store/actions/login-logout.action';
import { normalizeHttpError, withdrawOn } from '../../../util';
import { RecommendationsPanelConnector } from '../../connectors/recommendations-panel-connector';
import { UserActions } from '../actions';

@Injectable()
export class RecommendationEffects {
  constructor(
    private actions$: Actions,
    private connector: RecommendationsPanelConnector,
    private userIdService: UserIdService
  ) {}

  private contextChange$ = this.actions$.pipe(ofType(LoginLogoutActionTypes.Logout));

  /**
   * Attempts to store the *FIRST PANEL* of any zone represented by the panelName of a load.
   *
   * The "first panel" bit is a simplification; later we'll (maybe?) want to load complete zones.
   * Or we wont; it's up to us!
   *
   */
  extractFirstPanelOfZone$: Observable<UserActions.LoadRecommendationSuccess | UserActions.LoadRecommendationFail> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.RecommendationActionTypes.LoadRecommendation),
        mergeMap((action: UserActions.LoadRecommendation) => {
          return this.userIdService.takeUserId().pipe(
            // TODO: move userId to action. /that/ is the way
            mergeMap((userId) => {
              const { panelName, productCode, articleCode, ...otherParameters } = action.lookup;
              return this.connector.getZone(userId, panelName, productCode, articleCode, otherParameters).pipe(
                map((panelResponse) => new UserActions.LoadRecommendationSuccess(panelResponse, action.lookup)),
                catchError((error) => of(new UserActions.LoadRecommendationFail(action.lookup, normalizeHttpError(error))))
              );
            })
          );
        }),
        withdrawOn(this.contextChange$)
      )
  );
}
